import { jsx } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M14.4 6L14 4H5V21H7V14H12.6L13 16H20V6H14.4Z", fill: "currentColor" }) });
export default SvgFlag;
